import CustomFormInput from "./forms/CustomFormInput";
import "./GuestAccountOptIn.css";

/**
 * GuestAccountOptIn
 *
 * The inline "create a free account" opt-in shown to guests during checkout
 * (ticket purchase + lesson booking). Presentational only — all state and the
 * register/login logic live in the useGuestAccountCreation hook; the parent
 * passes the hook's values in and decides when to act on them.
 *
 * Shown BY DEFAULT and hidden by the parent (via `visible`) once the email is
 * recognised as an existing account (that case routes to login instead).
 * Unchecked by default so continuing as a guest stays the zero-friction path.
 *
 * Scoped styles live under `.guest-account-optin` in GuestAccountOptIn.css.
 */
const GuestAccountOptIn = ({
    visible = true,
    label,
    checked,
    onChange,
    password,
    onPasswordChange,
    passwordError,
    passwordHint = "At least 5 characters. We'll use your name and email above.",
}) => {
    if (!visible) return null;

    return (
        <div className="guest-account-optin">
            <CustomFormInput
                type="checkbox"
                variant="purple"
                label={label}
                checked={checked}
                onChange={onChange}
            />
            {checked && (
                <div className="guest-account-optin-password">
                    <label className="guest-account-optin-label">
                        Password <span className="guest-account-optin-required">*</span>
                    </label>
                    <p className="guest-account-optin-hint">{passwordHint}</p>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => onPasswordChange(e.target.value)}
                        placeholder="Create a password"
                        autoComplete="new-password"
                        className={`guest-account-optin-input${passwordError ? " has-error" : ""}`}
                    />
                    {passwordError && (
                        <p className="guest-account-optin-error">{passwordError}</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default GuestAccountOptIn;
